'use client';
import React, { forwardRef } from 'react';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Auth from '@/components/app/auth/components';
import Section from '@/components/app/product/components/@shared/section';
import RoundedIcon from '@/components/shared/components/icon/rounded';

import useCommonModalStore from '@/store/common-modal-store';

import { DATA_CY_ADD_QUESTION_BOX, DATA_CY_SIGN_IN_BUTTON } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

const LoginAlert = forwardRef<HTMLDivElement | HTMLElement>((props, ref) => {
  const { setShow } = useCommonModalStore();
  const handleAuthModal = () => {
    setShow(true, {
      DialogPanelProps: {
        className: 'rounded-xl overflow-hidden shadow-none!  p-0! bg-transparent! ',
      },
      Body() {
        return <Auth />;
      },
    });
  };
  return (
    <Section className='mx-0! p-1.5!'>
      <Container data-cy={DATA_CY_ADD_QUESTION_BOX} className='relative h-full w-full'>
        <Container className='absolute h-[96px] w-full rounded-md bg-linear-to-b from-[#FFB616]/[7%] to-[#ffb61600]' />
        <Container
          center
          className='relative z-10 justify-between px-[27px] py-[38px]'
          ref={ref}
        >
          <Container center className='gap-2'>
            <RoundedIcon
              className='h-[40px] w-[40px]'
              icon={
                <XImage
                  src={imagesList.icons.question}
                  alt={productLocalization.questions}
                  width={20}
                  height={20}
                />
              }
            />
            <Text>{productLocalization.loginToQuestion}</Text>
          </Container>
          <Button
            data-cy={DATA_CY_SIGN_IN_BUTTON}
            onClick={handleAuthModal}
            className='hover:bg-[#EB8800]'
          >
            {productLocalization.loginOrRegister}
          </Button>
        </Container>
      </Container>
    </Section>
  );
});

export default LoginAlert;
